<template>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(image, index) in images" :key="index">
                <img class="swipe-image" :src="getImagePath(image)">
            </div> 
        </div>
        <div class="swiper-pagination" v-if="pagination"></div> 
        <div class="swiper-button-next" v-if="navigation"></div>
        <div class="swiper-button-prev" v-if="navigation"></div> 
    </div>
</template>

<script>
import Swiper from 'swiper'
let imageSlider = undefined;
export default {
    name: "shopHero",
    props: {
        pagination: { type: Boolean, required: false, default: true },
        navigation: { type: Boolean, required: false, default: false },
        loop: { type: Boolean, required: false, default: true },
        speed: { type: Number, required: false, default: 1000 },
        delay: { type: Number, required: false, default: 8000 },
        direction: { type: String, required: false, default: 'horizontal' },
        slidesPerView: { type: Number, required: false, default: 1 },
        images: { type: Array, required: false},
        spaceBetween: { type: Number, required: false, default: 10 }
    },
    mounted() {
        this.createSlider();
    },
    methods: {
        createSlider() {
            imageSlider =  new Swiper('.swiper-container', {
                spaceBetween: this.spaceBetween,
                direction: this.direction,
                slidesPerView: this.slidesPerView,
                speed: 1000,
                pagination: this.usePagination(),
                navigation: this.useNavigation(),
                autoplay: { delay: this.delay },
            });
            
            if(this.loop)
                this.startAutoPlay();
            else this.stopAutoPlay();
        },
        stopAutoPlay() {
            imageSlider.autoplay.stop();
        },
        startAutoPlay() {
            imageSlider.autoplay.start();
        },
         usePagination() {
            if(this.pagination)
            {
                return {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                    dynamicBullets: true, 
                };
            }
            else return {};
        },
        useNavigation() {
            if(this.navigation)
            {
               return {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                };
            }
            else return {};
        },
        getImagePath(image) {
            var cdn = this.$store.getters['CONTENTDATA/CDN'];
            return cdn + image;
        }
    }
}
</script>

<style lang="postcss">

.swiper-container {
    width: 100%;
    height: 700px;
    overflow: hidden;
}

.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.swiper-pagination {
}

.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    color:#000;
    opacity: 1;
    background: rgba(0,0,0,0.2);
}
.swiper-pagination-bullet-active {
    color:#fff;
    background: #464646 !important;
}

@media screen and (max-width: 780px) {
    .swiper-container {
        width: 100%;
        height: 500px;
    }
    .swipe-image {
        height: 100%;
        width: 100%;
    }

    .swiper-pagination {
    }
}
</style>